import React from "react";
import { SimulatorProps, VortexSimulatorProps } from "../interfaces/interfaces";
import {
  GasSimulatorProps,
  GasSimulatorResultProps,
  PressureSimulatorProps,
  PressureSimulatorResultProps,
  SandSimulatorProps,
  SandSimulatorResultProps,
} from "../interfaces/interfaces";
import {
  initial_gas_simulator_state,
  initial_gas_simulator_results,
  initial_sand_simulator_state,
  initial_sand_simulator_results,
  initial_press_simulator_state,
  initial_press_simulator_results,
  initial_simulator_state,
  vortex_simulator_state,
} from "../utils/data";

interface Props {
  simulatorState: SimulatorProps;
  gasSimulatorValues: GasSimulatorProps;
  vortexSimulatorValues: VortexSimulatorProps;
  gasSimulatorResults: GasSimulatorResultProps;
  sandSimulatorValues: SandSimulatorProps;
  sandSimulatorResults: SandSimulatorResultProps;
  pressSimulatorValues: PressureSimulatorProps;
  pressSimulatorResults: PressureSimulatorResultProps;
  handleCancelSimulation: () => void;
  handleResetSimulation: () => void;
  onUpdateOptSimulator: (
    item: "sand" | "gas" | "pressure",
    value: string
  ) => void;
  onUpdateGasSimulatorValues: (
    item: string,
    values: any,
    vortex?: boolean
  ) => void;
  onUpdateSandSimulatorValues: (item: string, values: any) => void;
  onUpdatePressSimulatorValues: (item: string, values: any) => void;
  fetchTechSolution: (id: number | string) => void;
  onSimulateGas: (vortex?: boolean) => void;
  onSimulateSand: () => void;
  onSimulatePressure: () => void;
  mergeVortexAndPressureDrop: () => void;
}

const SimulatorContext = React.createContext<Props>({
  simulatorState: initial_simulator_state,
  gasSimulatorValues: initial_gas_simulator_state,
  vortexSimulatorValues: vortex_simulator_state,
  gasSimulatorResults: initial_gas_simulator_results,
  sandSimulatorValues: initial_sand_simulator_state,
  sandSimulatorResults: initial_sand_simulator_results,
  pressSimulatorValues: initial_press_simulator_state,
  pressSimulatorResults: initial_press_simulator_results,
  handleCancelSimulation: () => {},
  handleResetSimulation: () => {},
  onUpdateOptSimulator: () => {},
  onUpdateGasSimulatorValues: () => {},
  onUpdateSandSimulatorValues: () => {},
  onUpdatePressSimulatorValues: () => {},
  fetchTechSolution: () => {},
  onSimulateGas: () => {},
  onSimulateSand: () => {},
  onSimulatePressure: () => {},
  mergeVortexAndPressureDrop: () => {},
});

export default SimulatorContext;
